<template>
  <vue-final-modal 
    v-model="showM" 
    classes="modal-container" 
    content-class="modal-content-f w800"
  >
    <div class="modal-header">
      <b>Registrovaní - {{ webinarName }}</b>
      <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal__content">
      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border" role="status">
          <span class="sr-only">Načítání...</span>
        </div>
      </div>

      <div v-else>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Email</th>
              <th>Jméno</th>
              <th>Příjmení</th>
              <th>Datum registrace</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="registrant in registrants" :key="registrant.email">
              <td>
                <a v-if="registrant.student_id" :href="`/students/${registrant.student_id}`" target="_blank">{{ registrant.email }}</a>
                <span v-else>{{ registrant.email }}</span>
              </td>
              <td>{{ registrant.first_name }}</td>
              <td>{{ registrant.last_name }}</td>
              <td>{{ formatDate(registrant.created_at) }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <div v-if="pagination.total_pages > 1" class="d-flex justify-content-between align-items-center mt-3">
          <div>
            Zobrazeno {{ (pagination.current_page - 1) * pagination.per_page + 1 }} 
            - {{ Math.min(pagination.current_page * pagination.per_page, pagination.total_count) }}
            z {{ pagination.total_count }} registrovaných
          </div>
          <nav>
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                <a class="page-link" href="#" @click.prevent="loadPage(pagination.current_page - 1)">
                  Předchozí
                </a>
              </li>
              <li 
                class="page-item" 
                v-for="page in visiblePages" 
                :key="page"
                :class="{ active: page === pagination.current_page }"
              >
                <a class="page-link" href="#" @click.prevent="loadPage(page)">
                  {{ page }}
                </a>
              </li>
              <li class="page-item" :class="{ disabled: pagination.current_page === pagination.total_pages }">
                <a class="page-link" href="#" @click.prevent="loadPage(pagination.current_page + 1)">
                  Další
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div v-else class="mt-3">
          Celkem: {{ pagination.total_count }} registrovaných
        </div>
      </div>
    </div>

    <div class="modal__action">
      <button class="btn btn-outline-dark" @click="hideModal">
        Zavřít
      </button>
    </div>
  </vue-final-modal>
</template>

<script>
import axios from "axios";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";
import moment from "moment";

export default {
  name: "registrants-modal",
  mixins: [modalKkMixin],
  data() {
    return {
      webinarId: null,
      webinarName: '',
      registrants: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        per_page: 100
      },
      loading: false
    };
  },
  computed: {
    visiblePages() {
      const current = this.pagination.current_page;
      const total = this.pagination.total_pages;
      const delta = 2; // Kolik stránek zobrazit před a po aktuální
      
      let pages = [];
      let start = Math.max(1, current - delta);
      let end = Math.min(total, current + delta);
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      
      return pages;
    }
  },
  methods: {
    async showModal(webinarId, webinarName) {
      this.webinarId = webinarId;
      this.webinarName = webinarName;
      this.pagination.current_page = 1;
      this.showM = true;
      await this.loadRegistrants();
    },
    async loadRegistrants() {
      this.loading = true;
      try {
        const response = await axios.get(
          `/ever_webinars/${this.webinarId}/registrants.json`,
          { params: { page: this.pagination.current_page } }
        );
        
        this.registrants = response.data.registrants;
        this.pagination = response.data.pagination;
      } catch (error) {
        console.error('Chyba při načítání registrantů:', error);
        alert('Nepodařilo se načíst seznam registrovaných');
      } finally {
        this.loading = false;
      }
    },
    async loadPage(page) {
      if (page < 1 || page > this.pagination.total_pages) return;
      this.pagination.current_page = page;
      await this.loadRegistrants();
    },
    formatDate(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD.MM.YYYY HH:mm');
    }
  }
};
</script>

<style scoped>
.table {
  margin-bottom: 0;
}
.pagination {
  margin-bottom: 0;
}
</style>
